import Loader from '@/components/Loader.tsx';
import { useGetUserPersonalData } from '@/hooks/useGetUserPersonalData.util.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import QuizFinishedMessageDesktop from '@/views/process/components/quizFinished/QuizFinishedMessageDesktop.tsx';
import QuizFinishedMessageMobile from '@/views/process/components/quizFinished/QuizFinishedMessageMobile.tsx';
import UserSkillsAssessment from '@/views/process/components/skillsAssessmentCollected/UserSkillsAssessment.tsx';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

const QuizFinishedPage: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslationWithPrefix('quizFinishedPage');
  const { t: tButtons } = useTranslationWithPrefix('quizInitializedPage.buttons');

  const { isGetting, userPersonalData } = useGetUserPersonalData();
  const [showSkills, setShowSkills] = useState(false);

  const Message = isMobile ? QuizFinishedMessageMobile : QuizFinishedMessageDesktop;
  const areas = userPersonalData?.areaOfInterests?.map(item => item.description).join(', ');

  return (
    <div className="flex flex-column w-full items-center gap-24 gap-md-10 mt-40">
      {isGetting && <Loader />}
      {showSkills ? (
        <UserSkillsAssessment />
      ) : (
        <>
          <Message
            message={t('messages.0.message')}
            subMessage={t('messages.0.subMessage', { areas })}
            additionalMessage={t('messages.1.subMessage')}
          />
          <Button className="btn btn-primary w-full sm:w-1/3" onClick={() => setShowSkills(true)}>
            {tButtons('next')}
          </Button>
        </>
      )}
    </div>
  );
};

export default QuizFinishedPage;
